import { Theme, css } from '@emotion/react';

export const iconSpacing = ({ spacing }: Theme) => css`
  margin-right: ${spacing(2)}px;
`;

export const listDisplayContainer = css`
  display: flex;
  align-items: center;
`;
